<template>
    <div>
      <H4>Notifications VIEW FOR SENIOR! NEEDS WORK!!!</H4>  
        <b-card>
            <b-tabs>
              <b-tab title="Escalations">Tab1</b-tab>
              <b-tab title="High Priority">Tab2</b-tab>
              <b-tab title="Medium Priority">Tab3</b-tab>
              </b-tabs>
        
        </b-card>
    
    </div>
  </template>
  
  <script>
  
  export default {
    components: {

    },
  
    data() {
      return {
       
        CompanyName: this.$Company,
        UserURN: this.$UserURN,
        UserName: this.$FullName,

      };
    },
  
    async mounted() {},
  
    methods: {},
  
    watch: {
      location() {
        this.filterLocations();
      },
    },
  };
  </script>
  
  <style scoped>
 

  </style>
  